/* ============
 * Default Layout
 * ============
 *
 * Used for all pages except login
 *
 */

import authService from './../../services/auth';
import store from './../../store';

export default {
  data() {
    return {
      multipleAccounts: store.state.auth.managed_sps.length > 1,
      spName: '',
      hasRoleLists: false,
      hasRoleAdmin: false,
      hasRoleProfiles: false,
    };
  },
  methods: {
    logout() {
      authService.logout();
    },
    test1() {
      console.log('test1');
      // this.$router.push({ name: 'lists.lookups', params: {} });
    },
  },
  beforeMount() {
    // console.log('store');
    // console.log(store.state.auth.managed_sps);
    // console.log(store.state.auth.selected_sp);
    if (store.state.auth.selected_sp && store.state.auth.selected_sp.sp_id) {
      this.spName = store.state.auth.selected_sp.name;
      // console.log('selected_sp');
      // console.log(store.state.auth.selected_sp);
      if ((store.state.auth.selected_sp.roles) && Array.isArray(store.state.auth.selected_sp.roles)) {
        for (let ri = 0; ri < store.state.auth.selected_sp.roles.length; ri += 1) {
          if (store.state.auth.selected_sp.roles[ri] == "admin") {
            this.hasRoleAdmin = true;
          }
          if (store.state.auth.selected_sp.roles[ri] == "lists") {
            this.hasRoleLists = true;
          }
          if (store.state.auth.selected_sp.roles[ri] == "profiles") {
            this.hasRoleProfiles = true;
          }
        }
      } // isArray
    }
    // console.log('done');
  },
};



// WEBPACK FOOTER //
// ./src/app/layouts/default/default.js